import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../services/axios';

// Thunk actions
export const fetchStates = createAsyncThunk(
  'location/states',
  async () => {
    const response = await axiosInstance.get('/location/states');
    return response.data;
  }
);

export const fetchCities = createAsyncThunk(
  'location/cities',
  async (stateId) => {
    const response = await axiosInstance.get(`/location/cities/${stateId}`);
    return response.data;
  }
);

const locationSlice = createSlice({
  name: 'location',
  initialState: {
    states: [],
    cities: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // States
      .addCase(fetchStates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStates.fulfilled, (state, action) => {
        state.loading = false;
        state.states = action.payload;
      })
      .addCase(fetchStates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Cities
      .addCase(fetchCities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCities.fulfilled, (state, action) => {
        state.loading = false;
        state.cities = action.payload;
      })
      .addCase(fetchCities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export default locationSlice.reducer;